import { skipIfNull } from '@proscom/prostore';
import { useRetriableGraphqlVars } from '../../common/useRetriableGraphqlVars';
import { QUERY_GET_ROLE } from '../../graphql/queries/roles';

const roleQueryOptions = {
  query: QUERY_GET_ROLE,
  mapData: (result) => result.role,
  skipQuery: skipIfNull(null)
};

export function useRole(id, networkOnly = false) {
  return useRetriableGraphqlVars({
    queryOptions: roleQueryOptions,
    variableCreator: [
      () =>
        id
          ? {
              id
            }
          : null,
      [id]
    ],
    options: {
      apolloOptions: {
        fetchPolicy: networkOnly ? 'network-only' : 'cache-first'
      }
    }
  });
}
